import React from 'react';
import { TermsOfUseWrapper } from '../../v2/components/terms-of-use';
import { TERMS_OF_USE_CONTENT_OLD } from '../../v2/constants';
import TermsOfUseTableOfContentOld from '../../v2/components/terms-of-use/TableOfContentOld';
import HeroContentOld from '../../v2/components/terms-of-use/HeroContentOld';
import DescriptionOld from '../../v2/components/terms-of-use/DescriptionOld';

const TermsOfUseOld: React.FC = () => (
  <TermsOfUseWrapper
    hero={<HeroContentOld />}
    content={TERMS_OF_USE_CONTENT_OLD}
    tableOfContents={<TermsOfUseTableOfContentOld />}
    description={<DescriptionOld />}
  />
);

export default TermsOfUseOld;
